/*  ========================================================================
    # Main JavaScript
    ========================================================================  */

import Accordion from './scripts/accordion';
import Gallery from './scripts/gallery';
import HeaderMetaMenu from './scripts/header-meta-menu';
import HeaderMobile from './scripts/header-mobile';
import PageStatus from './scripts/page-status';
import TabsWithGallery from './scripts/tabs-with-gallery';
import ContactForm from './scripts/contact-form.js';
import HeaderDesktopSub from './scripts/header-desktop-sub';

const scripts = [Accordion, Gallery, HeaderMetaMenu, HeaderMobile, PageStatus, TabsWithGallery, ContactForm, HeaderDesktopSub];

document.addEventListener('DOMContentLoaded', () => {
  if (scripts.length > 0 && scripts !== undefined) {
    scripts.forEach(script => {
      script.init();
    });
  }
});
